var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Dashboard } from "../model/Dashboard";
import { DashboardContainer } from "./Dashboard";
var DashboardWrapper = /** @class */ (function (_super) {
    __extends(DashboardWrapper, _super);
    function DashboardWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.dashboard = new Dashboard();
        _this._setFromProps(_this.props);
        return _this;
    }
    DashboardWrapper.prototype._setFromProps = function (props) {
        this.dashboard.router = props.router;
        this.dashboard.addApp = props.addApp;
        this.dashboard.setConfig(props.config);
        this.dashboard.loader = props.loader;
        this.dashboard.saver = props.saver;
        this.dashboard.saveDelay = props.saveDelay;
    };
    DashboardWrapper.prototype.componentWillReceiveProps = function (nextProps) {
        this.dashboard.close();
        this._setFromProps(nextProps);
    };
    DashboardWrapper.prototype.componentWillMount = function () {
        if (this.props.loader) {
            this.dashboard.load();
        }
    };
    DashboardWrapper.prototype.componentWillUnmount = function () {
        this.dashboard.close();
    };
    DashboardWrapper.prototype.render = function () {
        return React.createElement(DashboardContainer, { className: this.props.className, dashboard: this.dashboard, host: this.props.host, styles: this.props.styles });
    };
    return DashboardWrapper;
}(React.Component));
export { DashboardWrapper };
